module.exports = __webpack_public_path__ + "static/media/ic_comment.251d31d7.png";